import { createRenderStep } from './render-step.mjs';
var stepsOrder = ["prepare", "read", "update", "preRender", "render", "postRender"];
var maxElapsed = 40;

function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  var runNextFrame = false;
  var useDefaultElapsed = true;
  var state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  var steps = stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(function () {
      return runNextFrame = true;
    });
    return acc;
  }, {});

  var processStep = function processStep(stepId) {
    return steps[stepId].process(state);
  };

  var processBatch = function processBatch() {
    var timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder.forEach(processStep);
    state.isProcessing = false;

    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };

  var wake = function wake() {
    runNextFrame = true;
    useDefaultElapsed = true;

    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };

  var schedule = stepsOrder.reduce(function (acc, key) {
    var step = steps[key];

    acc[key] = function (process) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };

    return acc;
  }, {});

  var cancel = function cancel(process) {
    return stepsOrder.forEach(function (key) {
      return steps[key].cancel(process);
    });
  };

  return {
    schedule: schedule,
    cancel: cancel,
    state: state,
    steps: steps
  };
}

export { createRenderBatcher, stepsOrder };